var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-icon-button',{staticClass:"share",on:{"click":_vm.click}},[_vm._v("sci-share")])}
var staticRenderFns = []

export { render, staticRenderFns }